
export const isAccountVerified = () => {
  const email = localStorage.getItem("email");
  if (email) return true;
  else return false;
};


export const REMOVE_ELEMENT = (elementId) => {
  const elementToRemove = document.getElementById(elementId);
  if (!elementToRemove) {
    console.error(`Element with id ${elementId} not found!`);
    return;
  }

  elementToRemove.remove();
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};